// es-CL formatting helpers.

const MS_PER_MINUTE = 60_000;
const MS_PER_DAY = 24 * 60 * 60 * 1000;

const CLP = new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 });

export function formatCLP(n: number): string {
  return CLP.format(n);
}

// Relative dates up to 7 days ago; absolute dd/mm/aaaa from day 8.
// observedAt is nullable upstream; a missing timestamp renders as an em dash.
export function formatRelativeDate(iso: string | null, now: Date = new Date()): string {
  if (!iso) return '—';
  const d = new Date(iso);
  const diffMs = now.getTime() - d.getTime();
  const diffMin = Math.floor(diffMs / MS_PER_MINUTE);
  if (diffMin < 1) return 'hace instantes';
  if (diffMin < 60) return `hace ${diffMin} min`;
  const diffH = Math.floor(diffMin / 60);
  if (diffH < 24) return `hace ${diffH} h`;
  const diffD = Math.floor(diffH / 24);
  if (diffD === 1) return 'ayer';
  if (diffD <= 7) return `hace ${diffD} d`;
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yyyy = d.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
}

export function isStale(iso: string | null, now: Date = new Date(), days = 7): boolean {
  if (!iso) return false;
  return now.getTime() - new Date(iso).getTime() > days * MS_PER_DAY;
}
